/**
 * Environment configuration
 * Supports both build-time (Vite) and runtime (Docker) environment variables
 */

declare global {
  interface Window {
    _env_?: {
      VITE_MSAL_CLIENT_ID?: string;
      VITE_MSAL_TENANT_ID?: string;
      VITE_MSAL_REDIRECT_URI?: string;
      VITE_API_BASE_URL?: string;
      VITE_JIRA_BASE_URL?: string;
    };
  }
}

const getEnvVar = (key: string, defaultValue?: string): string => {
  if (typeof window !== 'undefined' && window._env_) {
    const value = window._env_[key as keyof typeof window._env_];
    if (value) return value;
  }

  const viteEnv = import.meta.env[key];
  if (viteEnv) return viteEnv as string;

  if (defaultValue !== undefined) return defaultValue;

  throw new Error(
    `Missing required environment variable: ${key}\n` +
    `In development: Set in .env.local file\n` +
    `In Docker: Pass as environment variable at runtime`
  );
};

export const env = {
  msalClientId: getEnvVar('VITE_MSAL_CLIENT_ID'),
  msalTenantId: getEnvVar('VITE_MSAL_TENANT_ID'),
  msalRedirectUri: getEnvVar('VITE_MSAL_REDIRECT_URI', 'http://localhost:5173'),
  apiBaseUrl: getEnvVar('VITE_API_BASE_URL', '/api/v1'),
  jiraBaseUrl: getEnvVar('VITE_JIRA_BASE_URL', 'https://cancom-at.atlassian.net'),
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;
